import { LEGAL_CANCELLATION_HEADING } from './0-heading.md';
import { LEGAL_RIGHT_OF_CANCELLATION } from './1-right-of-cancellation.md';
import { LEGAL_CANCELLATION_PROCEDURE } from './2-cancellation-procedure.md';
import { LEGAL_CANCELLATION_REFUND_POLICY } from './3-cancellation-refund-policy.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_CANCELLATION_POLICY_TEMPLATE_DE: string = `
	<!-- let sectionIndex = 0; subSectionIndex = 0; -->

	${LEGAL_CANCELLATION_HEADING}
	${LEGAL_RIGHT_OF_CANCELLATION}
	---
	${LEGAL_CANCELLATION_PROCEDURE}
	---
	${LEGAL_CANCELLATION_REFUND_POLICY}
`;
